import React from 'react';

import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { defaultGraphConfig, generateLabels } from 'utils/graphs';
import { DashboardEnvironmentsCostGraphFields } from 'modules/environments/interfaces';
import { formatCurrency } from 'utils/helpers';

interface EnvironmentCostGraphProps {
  dashboardEnvironmentCostGraph: DashboardEnvironmentsCostGraphFields;
}

const EnvironmentCostGraph = ({
  dashboardEnvironmentCostGraph,
}: EnvironmentCostGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(dashboardEnvironmentCostGraph?.metrics);

  const config = defaultGraphConfig(
    {
      labels,
      datasets: [
        {
          data: dashboardEnvironmentCostGraph?.metrics?.map(item => item?.cost),
          backgroundColor: palette.yellow,
          borderColor: palette.yellow,
          fill: false,
          tension: 0.4,
        },
      ],
    },
    true
  );

  config.options.tooltips = {
    callbacks: {
      label(tooltipItem) {
        return formatCurrency(tooltipItem.value);
      },
    },
    displayColors: false,
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { dashboardEnvironmentCostGraph },
}: ApplicationState) => ({
  dashboardEnvironmentCostGraph,
});

export default connect(mapStateToProps, {})(EnvironmentCostGraph);
